// This function allow to reference async chunks
__webpack_require__.miniCssF = function(chunkId) {
	// return url for filenames based on template
	return "css/" + chunkId + "." + {"310":"215abe99","848":"933bb575"}[chunkId] + ".css";
};